import React, { Fragment } from "react";

import Header from "../../components/header/header";

import "./hiring-party-terms.scss";

const HiringPartyTerms = () => (
  <Fragment>
    <Header />
    <section className="page_container"></section>
  </Fragment>
);

export default HiringPartyTerms;
